module.exports = __webpack_public_path__ + "static/img/step3.4acd97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step3.png
// module id = wb7n
// module chunks = 1